import { SortDirectionType } from '@rio-cloud/rio-uikit/utils/SortUtils';

// INFO: thread entity for client usage on the store type
export type TChatThread = {
  threadId: string;
  title: string;
  timestamp: string;
  isFavorite: boolean;
};

export type ThreadPagination = {
  totalThreads: number;
  totalPages: number;
  currentPage: number;
  limit: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  sortOrder?: SortDirectionType;
  onlyFavorites?: boolean;
};

// INFO: Fetch threads type for client usage on the store
export type ThreadData = {
  threads: TChatThread[];
  pagination: ThreadPagination;
};

// INFO: Lifecycle of restoring the persisted active thread after a page reload.
// DONE is terminal and is the only status that allows the chat empty states to render.
export enum EActiveThreadRestoreStatus {
  // INFO: A thread id was read from sessionStorage but its messages have not been requested yet.
  // The app does not know whether the chat is empty, so no empty state may render.
  IDLE = 'idle',
  // INFO: The message history request for the persisted thread is in flight.
  PENDING = 'pending',
  // INFO: Terminal. Reached when the request settles (fulfilled or rejected), when there was
  // nothing to restore, or when the user explicitly changed the active thread.
  DONE = 'done',
}

export type ThreadsState = {
  activeThreadId: string | null;
  loadingThreadIds: (string | null)[];
  isFetchingHistory: boolean;
  isAllThreadsInitialFetch: boolean;
  isFavoritesInitialFetch: boolean;
  pagination: ThreadPagination;
  activeThreadRestoreStatus: EActiveThreadRestoreStatus;
};

export type TUpdateThreadPayload = {
  threadId: string;
  updatedThread: Partial<TChatThread>;
};
